import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { intialLoading } from "../../store/screentransistion/actions";
import { saveUserDetails, lang as saveLang } from "../../store/trackinguser/actions";
import Layout from "../common/layoutred";
import game_logo from "../../assets/short-game-assets/game_logo.png";

import { Alert } from "@material-ui/lab";
import { isAndroid } from "react-device-detect";
import fullScreen from "../../utils/fullScreen";
import { connect } from "react-redux";
import {
	Button,
	FormControl,
	MenuItem,
	Select,
	TextField,
} from "@material-ui/core";
import { intialize } from "../../store/intialize/operations";

import "./style.scss";
import { BROWSER_DATA } from "../../store/types";

window.gtag("event", "REGISTRATION", {
	event_category: "REGISTRATION",
	event_label: "REGISTRATION",
});

const Registration = ({
	languages,
	zones,
	saveUserDetails,
	intialLoading,
	intialize,
	saveInitialLanguage,
}) => {
	const dispatch = useDispatch();

	const [india] = zones;
	const defaultLang = languages.find((l) => l.value == "ms");

	const [data, setData] = useState({
		zone: india._id,
		lang: defaultLang.value,
		number: "",
	});

	const [uniqueCode, setUniqueCode] = useState("");
	const [loading, setLoading] = useState(false);

	const activate = fullScreen();

	const [error, setError] = useState(false);
	const [msg, setMsg] = useState("Please enter valid details");

	const handleChange = (event) => {
		const { name, value } = event.target;
		setData({ ...data, [name]: value });
		dispatch({
			type: BROWSER_DATA,
			payLoad: { ...data, lang: event.target.value },
		});
	};

	const handleCodeChange = (e) => {
		const value = e.target.value;
		if (/^\d{0,6}$/.test(value)) {
			setUniqueCode(value);
			setError(false);
		}
	};

	const register = (event) => {
		event.preventDefault();
		const trimmed = uniqueCode.trim();
		if (!trimmed || !/[a-zA-Z0-9]/.test(trimmed)) {
			setError(true);
			setMsg("Please enter a valid unique code");
			return;
		}

		if (!data.lang || !data.zone) {
			setError(true);
			setMsg("Please select a language");
			return;
		}

		setLoading(true);
		setError(false);
		saveUserDetails({ number: trimmed });

		intialize(
			() => {
				setLoading(false);
				saveInitialLanguage(data.lang);
				dispatch({
					type: BROWSER_DATA,
					payLoad: { ...data, number: trimmed },
				});
				if (isAndroid) {
					activate();
				}
				intialLoading();
			},
			(errCode) => {
				setLoading(false);
				setError(true);
				if (errCode === 403) {
					setMsg("You have already completed the game!");
				} else {
					setMsg("Something went wrong. Please try again.");
				}
			},
			trimmed
		);
	};

	return (
		<>
			<Layout>
				<div className="registration__container">
					<form onSubmit={register}>
						<div className="form_control landing_container">
							<img
								src={game_logo}
								alt="landing_image"
								className="landing_content_image"
							/>
						</div>
						<FormControl
							variant="outlined"
							size="small"
							style={{
								width: "100%",
								marginTop: "20px",
								backgroundColor: "white",
							}}>
							<Select
								id="simple-select"
								name="lang"
								value={data.lang}
								onChange={handleChange}
								style={{
									fontSize: 18,
								}}>
								{languages
									? languages.map((lan) => (
											<MenuItem key={lan.value} value={lan.value}>
												{lan.language}
											</MenuItem>
									  ))
									: null}
							</Select>
						</FormControl>
						<TextField
							variant="outlined"
							placeholder="Enter Unique Code"
							value={uniqueCode}
							onChange={handleCodeChange}
							style={{
								width: "100%",
								marginTop: "20px",
								backgroundColor: "white",
							}}
							inputProps={{
								style: { fontSize: 18, padding: "14px" },
								maxLength: 6,
								inputMode: "numeric",
							}}
						/>
						<div className="_button_container">
							<Button
								type="submit"
								variant="contained"
								className="_button"
								disabled={loading}
								style={{ width: "100%" }}>
								{loading
									? "Loading..."
									: data.lang == "en"
									? "START"
									: "MULAKAN"}
							</Button>
						</div>
						<div className="form__control error__msg">
							{error ? (
								<Alert severity="error">
									<h3>{msg}</h3>
								</Alert>
							) : null}
						</div>
					</form>
				</div>
			</Layout>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		languages: state.intialize.languages,
		zones: state.intialize.zones,
	};
};

const mapDispathToProps = (dispatch) => {
	return {
		saveUserDetails: (details) => dispatch(saveUserDetails(details)),
		intialLoading: () => dispatch(intialLoading()),
		intialize: (success, failure, token) =>
			dispatch(intialize(success, failure, token)),
		saveInitialLanguage: (language) => dispatch(saveLang(language)),
	};
};

export default connect(mapStateToProps, mapDispathToProps)(Registration);
